export interface Category {
  id: string;
  name: string;
  icon: string;
  desc: string;
}

export interface Work {
  id: string;
  title: string;
  author: string;
  category: string;
  tags: string[];
  status: "连载中" | "已完结";
  chapters: number;
  rating: number;
  cover: string;
  description: string;
  latestChapter: string;
  updateTime: string;
  isExclusive?: boolean;
  isNew?: boolean;
  views: string;
}

export const categories: Category[] = [
  { id: "rexue", name: "热血冒险", icon: "ri-fire-line", desc: "燃向战斗与冒险旅程" },
  { id: "xuanyan", name: "玄幻仙侠", icon: "ri-sparkling-2-line", desc: "东方玄幻与修仙世界" },
  { id: "xiaoyuan", name: "校园青春", icon: "ri-graduation-cap-line", desc: "校园日常与青春成长" },
  { id: "chengshi", name: "都市职场", icon: "ri-building-line", desc: "都市生活与职场百态" },
  { id: "xuanji", name: "悬疑烧脑", icon: "ri-eye-close-line", desc: "推理悬疑与脑洞反转" },
  { id: "kejiao", name: "科幻机甲", icon: "ri-rocket-line", desc: "未来科技与机甲战斗" },
  { id: "gaoxiao", name: "搞笑日常", icon: "ri-emotion-laugh-line", desc: "轻松搞笑与日常吐槽" },
  { id: "lianai", name: "恋爱治愈", icon: "ri-heart-line", desc: "甜甜恋爱与治愈故事" },
];

export const works: Work[] = [
  {
    id: "shouhuo-zhi-xing",
    title: "守护之星",
    author: "星野早川",
    category: "热血冒险",
    tags: ["热血", "冒险", "友情"],
    status: "连载中",
    chapters: 128,
    rating: 9.6,
    cover: "https://readdy.ai/api/search-image?query=stylized%20anime%20illustration%20cover%20of%20a%20young%20hero%20holding%20a%20glowing%20star%20shield%2C%20dynamic%20action%20pose%2C%20warm%20coral%20orange%20and%20gold%20color%20palette%2C%20clean%20simple%20gradient%20background%20with%20soft%20light%20rays%2C%20epic%20adventure%20mood%2C%20vibrant%20cell%20shading%2C%20high%20detail%20anime%20art%20style&width=600&height=800&seq=work-shouhuo-01&orientation=portrait",
    description: "少年星野继承了传说中的守护之星，在一次次冒险中结识伙伴、守护家园。新作首发连载，每周三稳定更新，热血的战斗与真挚的友情交织成一段燃向传奇。",
    latestChapter: "第128话 星之觉醒",
    updateTime: "2小时前",
    isNew: true,
    views: "328万",
  },
  {
    id: "jianxian-fengyun",
    title: "剑仙风云录",
    author: "青崖子",
    category: "玄幻仙侠",
    tags: ["仙侠", "剑道", "东方玄幻"],
    status: "连载中",
    chapters: 96,
    rating: 9.4,
    cover: "https://readdy.ai/api/search-image?query=stylized%20anime%20illustration%20cover%20of%20a%20sword%20immortal%20wielding%20a%20glowing%20spirit%20sword%20on%20a%20misty%20mountain%20peak%2C%20ink%20wash%20and%20anime%20fusion%20style%2C%20deep%20teal%20and%20jade%20green%20palette%20with%20gold%20accents%2C%20elegant%20chinese%20xianxia%20atmosphere%2C%20clean%20cloudy%20background%2C%20detailed%20fantasy%20illustration&width=600&height=800&seq=work-jianxian-01&orientation=portrait",
    description: "少年问剑江湖，踏遍九州寻仙问道。东方玄幻经典题材，独家首发，细腻的剑道意境与宏大的修仙世界设定，带你走进快意恩仇的仙侠江湖。",
    latestChapter: "第96话 一剑破万法",
    updateTime: "5小时前",
    isExclusive: true,
    views: "412万",
  },
  {
    id: "xingkong-heiban",
    title: "星空黑白",
    author: "七濑遥",
    category: "校园青春",
    tags: ["校园", "青春", "成长"],
    status: "已完结",
    chapters: 210,
    rating: 9.1,
    cover: "https://readdy.ai/api/search-image?query=stylized%20anime%20illustration%20cover%20of%20two%20high%20school%20students%20under%20a%20starry%20night%20sky%2C%20youthful%20and%20nostalgic%20mood%2C%20warm%20amber%20and%20deep%20indigo%20night%20tones%2C%20gentle%20breeze%20and%20fireflies%2C%20soft%20gradient%20background%2C%20coming%20of%20age%20anime%20art%2C%20smooth%20cell%20shading%20illustration&width=600&height=800&seq=work-xingkong-01&orientation=portrait",
    description: "两颗遥不可及的星，在高中三年的校园里慢慢靠近。青春校园代表作，甜蜜与成长并存，细腻的画风和动人的台词让人笑着笑着就哭了。",
    latestChapter: "第210话 完结篇",
    updateTime: "1天前",
    views: "256万",
  },
  {
    id: "chengzhang-zhi-lu",
    title: "成长之路",
    author: "林木森",
    category: "都市职场",
    tags: ["职场", "都市", "成长"],
    status: "连载中",
    chapters: 74,
    rating: 8.8,
    cover: "https://readdy.ai/api/search-image?query=stylized%20anime%20illustration%20cover%20of%20a%20determined%20young%20professional%20in%20a%20modern%20office%20with%20city%20skyline%20behind%2C%20urban%20career%20growth%20theme%2C%20muted%20teal%20and%20warm%20neutral%20palette%2C%20clean%20minimal%20background%2C%20motivational%20business%20mood%2C%20detailed%20modern%20anime%20style%20illustration&width=600&height=800&seq=work-chengzhang-01&orientation=portrait",
    description: "职场新人程悦从基层做起，一路披荆斩棘的成长故事。真实还原都市职场百态，独家内容首发，献给每一个正在努力发光的人。",
    latestChapter: "第74话 新的起点",
    updateTime: "昨天",
    isExclusive: true,
    views: "189万",
  },
  {
    id: "heimu-houdaoke",
    title: "幕后黑手",
    author: "诡局",
    category: "悬疑烧脑",
    tags: ["悬疑", "推理", "反转"],
    status: "连载中",
    chapters: 58,
    rating: 9.3,
    cover: "https://readdy.ai/api/search-image?query=stylized%20anime%20illustration%20cover%20of%20a%20mysterious%20detective%20silhouette%20in%20a%20dark%20corridor%20with%20hanging%20magnifying%20glass%20and%20puzzle%20pieces%2C%20suspenseful%20mood%2C%20deep%20amber%20and%20near%20black%20contrast%2C%20mysterious%20fog%2C%20clean%20dark%20background%2C%20thriller%20anime%20illustration%20style&width=600&height=800&seq=work-heimu-01&orientation=portrait",
    description: "每一集都是一场精心设计的谜局，幕后真正的黑手究竟是谁？烧脑悬疑新作首发，反转再反转的剧情让人欲罢不能，烧掉你的脑细胞。",
    latestChapter: "第58话 双面真相",
    updateTime: "3小时前",
    isNew: true,
    views: "203万",
  },
  {
    id: "jijia-jishi",
    title: "机甲纪元",
    author: "铁十字",
    category: "科幻机甲",
    tags: ["科幻", "机甲", "战争"],
    status: "连载中",
    chapters: 82,
    rating: 9.2,
    cover: "https://readdy.ai/api/search-image?query=stylized%20anime%20illustration%20cover%20of%20a%20giant%20mecha%20robot%20standing%20on%20a%20futuristic%20battlefield%20with%20glowing%20core%2C%20sci%20fi%20mecha%20theme%2C%20vibrant%20coral%20and%20teal%20energy%20glow%2C%20dynamic%20perspective%2C%20clean%20dark%20sky%20background%20with%20stars%2C%20detailed%20sci%20fi%20anime%20illustration&width=600&height=800&seq=work-jijia-01&orientation=portrait",
    description: "地球遭遇未知入侵，少年与巨型机甲命运相连。科幻机甲新番上架速递，硬核的机体设定与燃爆的战斗场面，机甲控的年度必读之作。",
    latestChapter: "第82话 星海对轰",
    updateTime: "4小时前",
    views: "297万",
  },
  {
    id: "doubi-riji",
    title: "豆比日记",
    author: "一颗黄豆",
    category: "搞笑日常",
    tags: ["搞笑", "日常", "沙雕"],
    status: "连载中",
    chapters: 156,
    rating: 9.0,
    cover: "https://readdy.ai/api/search-image?query=stylized%20comic%20illustration%20cover%20of%20a%20cheerful%20round%20little%20yellow%20character%20holding%20a%20pencil%20in%20a%20bright%20room%20full%20of%20cute%20stickers%20and%20notebooks%2C%20humorous%20comedy%20mood%2C%20warm%20yellow%20and%20cream%20palette%2C%20playful%20chibi%20style%2C%20clean%20cheerful%20background%2C%20funny%20anime%20comic%20art&width=600&height=800&seq=work-doubi-01&orientation=portrait",
    description: "记录日常沙雕生活的搞笑条漫，每一话都笑到停不下来。轻松治愈的下饭神器，独家首发更新，让你的烦恼一扫而空。",
    latestChapter: "第156话 吃货的一天",
    updateTime: "2小时前",
    isExclusive: true,
    views: "341万",
  },
  {
    id: "tianshi-de-xiehou",
    title: "天使的邂逅",
    author: "夏目花音",
    category: "恋爱治愈",
    tags: ["恋爱", "治愈", "校园"],
    status: "连载中",
    chapters: 45,
    rating: 9.5,
    cover: "https://readdy.ai/api/search-image?query=stylized%20anime%20illustration%20cover%20of%20a%20gentle%20boy%20meeting%20a%20girl%20with%20angelic%20soft%20wings%20on%20a%20blossoming%20tree%20street%2C%20romantic%20and%20healing%20mood%2C%20soft%20warm%20coral%20and%20peach%20tones%2C%20cherry%20blossom%20petals%20floating%2C%20clean%20dreamy%20background%2C%20sweet%20romance%20anime%20illustration&width=600&height=800&seq=work-tianshi-01&orientation=portrait",
    description: "当平凡少年遇见坠落人间的天使，一段治愈又心动的故事就此展开。恋爱治愈新作首发，画风细腻、台词温柔，甜到心坎里。",
    latestChapter: "第45话 与你相遇",
    updateTime: "6小时前",
    isNew: true,
    views: "172万",
  },
  {
    id: "longgu-wangzuo",
    title: "龙谷王座",
    author: "云中鹤",
    category: "热血冒险",
    tags: ["热血", "龙族", "王座"],
    status: "连载中",
    chapters: 143,
    rating: 9.4,
    cover: "https://readdy.ai/api/search-image?query=stylized%20anime%20illustration%20cover%20of%20a%20young%20warrior%20standing%20before%20a%20majestic%20dragon%20and%20an%20ancient%20throne%20in%20a%20ruined%20valley%2C%20epic%20fantasy%20mood%2C%20vibrant%20amber%20and%20deep%20green%20palette%2C%20dramatic%20lighting%2C%20clean%20epic%20background%2C%20detailed%20high%20fantasy%20anime%20art&width=600&height=800&seq=work-longgu-01&orientation=portrait",
    description: "龙谷苏醒，王座易主。少年背负龙族使命踏上夺回王座的征途。新番上架速递重磅推荐，恢弘的世界观与燃到极致的战斗。",
    latestChapter: "第143话 龙之试炼",
    updateTime: "1天前",
    views: "386万",
  },
  {
    id: "mima-2077",
    title: "密码2077",
    author: "零点计划",
    category: "科幻机甲",
    tags: ["科幻", "赛博", "推理"],
    status: "已完结",
    chapters: 120,
    rating: 8.9,
    cover: "https://readdy.ai/api/search-image?query=stylized%20anime%20illustration%20cover%20of%20a%20cyberpunk%20hacker%20in%20a%20neon%20lit%20futuristic%20city%20with%20holographic%20code%20and%20data%20streams%2C%20sci%20fi%20cyberpunk%20theme%2C%20teal%20and%20amber%20neon%20glow%20on%20dark%20background%2C%20futuristic%20mystery%20mood%2C%20clean%20night%20city%20backdrop%2C%20detailed%20cyberpunk%20anime%20illustration&width=600&height=800&seq=work-mima-01&orientation=portrait",
    description: "2077年的赛博都市，一场关于密码与真相的猫鼠游戏。科幻推理完结佳作，伏笔回收干净利落，结局令人拍案叫绝。",
    latestChapter: "第120话 完结篇",
    updateTime: "2天前",
    views: "228万",
  },
  {
    id: "haizi-xingli",
    title: "海边星旅",
    author: "南屿",
    category: "恋爱治愈",
    tags: ["治愈", "夏日", "青春"],
    status: "连载中",
    chapters: 39,
    rating: 9.2,
    cover: "https://readdy.ai/api/search-image?query=stylized%20anime%20illustration%20cover%20of%20two%20friends%20watching%20the%20sea%20at%20sunset%20with%20soft%20waves%20and%20seagulls%2C%20healing%20summer%20vibes%2C%20warm%20coral%20sunset%20and%20cream%20tones%2C%20relaxing%20calm%20mood%2C%20clean%20ocean%20background%2C%20gentle%20slice%20of%20life%20anime%20illustration&width=600&height=800&seq=work-haizi-01&orientation=portrait",
    description: "海边的夏天，少年少女们一起寻找属于彼此的星空。治愈系夏日新作，独家首发，清新画风抚平你所有焦虑。",
    latestChapter: "第39话 星空下的约定",
    updateTime: "8小时前",
    isExclusive: true,
    views: "145万",
  },
  {
    id: "chuan-yue-tangchao",
    title: "穿越大唐",
    author: "顾三金",
    category: "玄幻仙侠",
    tags: ["穿越", "大唐", "历史"],
    status: "连载中",
    chapters: 67,
    rating: 8.7,
    cover: "https://readdy.ai/api/search-image?query=stylized%20anime%20illustration%20cover%20of%20a%20modern%20young%20man%20dressed%20in%20traditional%20tang%20dynasty%20robes%20amid%20ancient%20chinese%20architecture%2C%20time%20travel%20fantasy%20theme%2C%20warm%20amber%20and%20jade%20green%20palette%2C%20ancient%20chinese%20street%20background%2C%20vibrant%20east%20asia%20anime%20illustration%20style&width=600&height=800&seq=work-chuanyue-01&orientation=portrait",
    description: "现代青年意外穿越大唐，凭一身现代知识搅动风云。穿越题材新作首发，历史与脑洞齐飞，笑点与爽点并存。",
    latestChapter: "第67话 长安论策",
    updateTime: "12小时前",
    isNew: true,
    views: "198万",
  },
];